import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { CognitoProvider } from "./utils/useCognito";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CognitoProvider>
    <ChakraProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </CognitoProvider>
);
